import type { CapiPlp } from 'types/capi/plp';

import FilterInteractionEvent, {
  type FilterPlacement,
  type FilterSelection
} from '~/events/FilterInteractionEvent';
import usePageData from '~/hooks/usePageData';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import { getFilters } from '~/routes/plps/plpViewProperties';

export default function useFilterInteraction() {
  const { isBot } = useRootData();
  const user = useUser();
  const plp = usePageData<CapiPlp>();

  return (selectedFilter: FilterSelection, placement: FilterPlacement) =>
    new FilterInteractionEvent({
      filters: getFilters(plp),
      gesture: 'click',
      guestId: user.guestId,
      isBot,
      placement,
      selectedFilters: [selectedFilter],
      sortKey: plp.applied_sort_key
    }).send();
}
